import { apiSlice } from '../../api-slice';

export const strengthApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createStrength: builder.mutation({
      query: (data) => ({
        url: 'strength',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Strength'],
    }),

    getStrength: builder.query({
      query: (params) => ({
        url: `strength`,
        method: 'GET',
        params,
      }),
      providesTags: ['Strength'],
      keepUnusedDataFor: 600,
    }),

    updateStrength: builder.mutation({
      query: (data) => ({
        url: `strength/${data.id}`,
        method: 'PUT',
        body: {
          name: data.name,
        },
      }),
      invalidatesTags: ['Strength'],
    }),

    deleteStrength: builder.mutation({
      query: (id) => ({
        url: `strength/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Strength'],
    }),
  }),
});

export const {
  useCreateStrengthMutation,
  useGetStrengthQuery,
  useDeleteStrengthMutation,
  useUpdateStrengthMutation,
} = strengthApi;
